import pro1 from '../assets/conference_app.png';
import pro2 from '../assets/Disney_api.png';
import pro3 from '../assets/Motorcycle_booking.png';
import pro4 from '../assets/Space_travel.png';
import pro5 from '../assets/leaderboard.png';
import pro6 from '../assets/covid.png';

const ProjectCardData = [
  {
    imgsrc: pro1,
    title: 'Conference-App',
    text: 'This is my Conference page where I am more focused on responsiveness. This project is one of the projects from my Microverse portfolio that aims to show you my skills in web design and responsive design. This project is based on an online website for a conference.',
    view: 'https://roshan-bajgain.github.io/Conference-App/',
    Source: 'https://github.com/roshan-bajgain/Conference-App',
  },
  {
    imgsrc: pro2,
    title: 'Disney Characters',
    text: 'Disney Character is a web application that shows data on Disney characters from the Disney API. Users can like the character and users can also leave a comment on any character on the comment popup. It shows the comments left by other people and gives an idea what people think about Disney characters.',
    view: 'https://thecodechaser.github.io/Disney-characters-webapp/dist/',
    Source: 'https://github.com/thecodechaser/Disney-characters-webapp',
  },
  {
    imgsrc: pro3,
    title: 'Motorcycle Booking',
    text: 'The app is the front-end version of the Motorcycle booking services. Built with react exclusively. The app fetches data from the API. The app allows you to see the details of the motorcycle. You can reserve the best motorcycle of your choice and have a test drive.',
    view: 'https://bikehub.vercel.app/',
    Source: 'https://github.com/vikipretium/motorcycle-testdrive-frontend',
  },
  {
    imgsrc: pro4,
    title: "Space Travelers' Hub",
    text: "Space Traveler's Hub is a single-page web application that fetches rockets, and missions from the SpaceX API. Users can book and cancel their reservations for rockets and missions. The application has three pages Rockets/Missions/MY Profile, My Profile page shows the list of reserved rockets and missions.",
    view: 'https://epic-hugle-d2e175.netlify.app/',
    Source: 'https://github.com/roshan-bajgain/space-travelers',
  },
  {
    imgsrc: pro5,
    title: 'Leaderboard',
    text: 'This is the Leaderboard project build with webpack and the objective of this project is to use the API. API stands for Application Programming Interface as it uses async and await JavaScript features to consume the API.',
    view: 'https://suspicious-golick-545a0f.netlify.app/',
    Source: 'https://github.com/roshan-bajgain/Leaderboard',
  },
  {
    imgsrc: pro6,
    title: 'Metrics-webapp',
    text: 'Covid19 Metrics is a web application that fetches covid data from API and renders it on the screen. It shows all countries with confirmed covid cases on the homepage, users can select any country and go to the details page. The details page shows other details for that specific country like recovered cases, confirmed cases, and deaths.',
    view: 'https://compassionate-mcnulty-d1bb1e.netlify.app/',
    Source: 'https://github.com/roshan-bajgain/metrics-webapp',
  },
];

export default ProjectCardData;
